//  Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { castToFloat } from 'helpers/reduxFormFunctions'

import {
  validateExtendedNumberRange,
} from 'validators/common'

const validateEarthStationResultsForm = v => {
  // Since redux-form v8, first render of the form does not have the actual initial values.
  // https://github.com/redux-form/redux-form/issues/4344
  if (Object.keys(v).length === 0) {
    return
  }

  // if there are no Earth Station cases for this given band, then don't need to validate the user's input
  // since the form will be disabled entirely.
  if (v.totalCaseNumbersCount === 0 || v.totalCaseNumbersCount === null) {
    return
  }

  const err = {}

  const caseNumbers = v.caseNumbers.trim()

  err.caseNumbers = validateExtendedNumberRange(caseNumbers, true)

  // if any of the values are greater than the total count, then we know it's an invalid value.
  // NOTE - we do not verify order here.
  if (
    !err.caseNumbers &&
    v.caseNumbers.trim().split(/[,:]/).find(d => castToFloat(d.trim()) > v.totalCaseNumbersCount)
  ) {
    err.caseNumbers = `A case number greater than ${v.totalCaseNumbersCount} was specified.`
  }

  return err
}

export default validateEarthStationResultsForm
